<template>
  <w-link-button
    :color="errors.length > 0 ? 'error' : 'primary'"
    @click="$emit('click:openDialog')"
  >
    <template #tooltip>
      <slot name="tooltip">
        {{ $t('Components.sentences.linkContact') }}
      </slot>
    </template>
  </w-link-button>
</template>

<script>
import contactPickerProps from "@/components/global_components/pickers/contact_picker/mixins/contact-picker-props";

export default {
  name: "WorkDefaultContactPicker",
  mixins: [contactPickerProps],
}
</script>
